module.exports = __webpack_public_path__ + "img/ParlamiDiMare-2.a4ef0138.jpeg";